var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDevicePhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1140_1704",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1140_1704)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3333 4.98969H14.8247H16.5567H17.299H20.6667C21.311 4.98969 21.8333 5.43279 21.8333 5.97938V26.0206C21.8333 26.5672 21.311 27.0103 20.6667 27.0103H11.3333C10.689 27.0103 10.1667 26.5672 10.1667 26.0206V5.97938C10.1667 5.43279 10.689 4.98969 11.3333 4.98969ZM17.2494 5C17.2058 5.0191 17.1753 5.06269 17.1753 5.1134C17.1753 5.18173 17.2306 5.23711 17.299 5.23711C17.3673 5.23711 17.4227 5.18173 17.4227 5.1134C17.4227 5.06269 17.3922 5.0191 17.3485 5H20C20 5.55228 19.5523 6 19 6H13C12.4477 6 12 5.55228 12 5H14.7752C14.7315 5.0191 14.701 5.06269 14.701 5.1134C14.701 5.18173 14.7564 5.23711 14.8247 5.23711H16.5567C16.625 5.23711 16.6804 5.18173 16.6804 5.1134C16.6804 5.06269 16.6499 5.0191 16.6062 5H17.2494ZM9 5.97938C9 4.8862 10.0447 4 11.3333 4H20.6667C21.9553 4 23 4.8862 23 5.97938V26.0206C23 27.1138 21.9553 28 20.6667 28H11.3333C10.0447 28 9 27.1138 9 26.0206V5.97938Z",
    fill: "#006EBD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevicePhone);
export default __webpack_public_path__ + "static/media/device-phone.078a0a6b74b7d0f583b0020d6bcd29c2.svg";
export { ForwardRef as ReactComponent };